import { OperatingSystemIcon, Typography } from '@compass/components'

import { CellWrapper } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

export const osDetailsColumn = columnHelper.display({
  id: 'osDetails',
  header: 'OS',
  cell: ({ row }) => {
    const browserDetails = row.original.browser_details

    if (!browserDetails) {
      return <Unavailable />
    }

    const value = [browserDetails.os, browserDetails.os_version].join(' ')

    return (
      <CellWrapper className='flex flex-row gap-2 items-center'>
        <OperatingSystemIcon type={browserDetails.os} className='size-4 shrink-0' />
        <Typography className='text-nowrap'>{value}</Typography>
      </CellWrapper>
    )
  },
})
